import React, { useState } from 'react';
import { connect } from 'react-redux';
import { translate, getUserNameToName, formatData } from '../../../utils/util';
import { withTranslation } from 'react-i18next';
import { Link, withRouter } from 'react-router-dom';
import { Modal } from '../../../components/UI/ComponentsUI';
import MovementTypeService from '../../../services/MovementTypeService';

const MovementTypeListItem = (props) => {
    const [openModalConfirm, setOpenModalConfirm] = useState(false);

    const onConfirm = (movementType) => {
        setOpenModalConfirm(false);
        props.movementTypeDelete(movementType, () => {
            props.history.go(-1);
        });
    };

    return (
        <>
            <span
                className="title sixth-text-color right"
                style={{ position: 'absolute', marginTop: '25px', right: '15px', zIndex: '999' }}
            >
                <i className="material-icons small sixth-text-color" onClick={() => { setOpenModalConfirm(true) }} style={{ cursor: 'pointer' }}>delete</i>
            </span>
            <Link
                style={{ display: 'block' }}
                to={props.route}
                onClick={(event) => {
                    if (props.onSelectChange) {
                        props.onSelectChange(event);
                    }
                }}
            >
                <span className="title sixth-text-color col s12">
                    {`${props.data.code}`}
                </span>
                <span className="second-text-color" style={{ marginLeft: '10px' }}>
                    <i className="mdi mdi-account" /> {getUserNameToName(props?.usersFromElog, props.data.updateBy)}
                </span>
                <span className="second-text-color" style={{ marginLeft: '10px' }}>
                    <i className="mdi mdi-history" /> {formatData(props.data?.updateOn)}
                </span>
            </Link>
            <Modal
                open={openModalConfirm}
                content={`${translate('fields.code', 'movement-type')} : ${props.data.code}`}
                dismissible={false}
                title={translate('messages.confirmation-delete', 'movement-type')}
                onCancel={() => setOpenModalConfirm(false)}
                onConfirm={() => onConfirm(props.data)}
            />
        </>
    );
};

const mapStateToProps = (state) => {
    return {
        user: state.userReducer.user,
        movementType: state.movementTypeReducer.movementType,
        usersFromElog: state.usersElogReducer.usersElog

    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        movementTypeDelete: (movementType, callback) => {
            dispatch(MovementTypeService.DeleteMovementType(movementType.movementTypeId, callback));
        }
    };
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(withTranslation()(MovementTypeListItem)));
